<script>
  export default {
    name: 'paper-status-label',
    props: ['statusId', 'statusKey', 'statusName']
  }
</script>

<template>
    <div>
        <el-tag type="default" :class="'label_'+statusKey">{{statusName}}</el-tag>
    </div>
</template>

<style lang="scss">
    .el-tag {
        padding: 4px 10px;
        height: 24px;
        line-height: 15px;

        &.label_nao_designado {
            background-color: #A384B7;
            color: #FFF;
        }

        &.label_aprovado_pela_triagem {
            background-color: #ED685D;
            color: #FFF;
        }

        &.label_em_avaliacao {
            background-color: #E4833C;
            color: #FFF;
        }

        &.label_finalizado,
        &.label_avaliado{
            background-color: #7ABA4E;
            color: #FFF;
        }
    }
</style>



// WEBPACK FOOTER //
// PaperStatusLabel.vue?bf8aeca0